import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { usePathName } from './usePathName';
import { sessionSetter } from '@utils/storage';

const excludedModules = new Set(['/administrator']);
const excludedPages = new Set([
  '/places/locations',
  '/standing-order/details',
  '/contractors/vehicles',
  '/contractors/personnel',
]);

export const usePageLayout = () => {
  const [toggleMenu, setToggleMenu] = useState<boolean>(true);

  const { pathname } = useLocation();
  const { currentPath } = usePathName();
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(() => {
    return sessionSetter.getItem<boolean>('navToggler') ?? true;
  });

  useEffect(() => {
    toggleMenu
      ? document.body.classList.add('myroom-user-active')
      : document.body.classList.remove('myroom-user-active');

    isSidebarOpen
      ? document.body.classList.add('nav-active')
      : document.body.classList.remove('nav-active');

    return () => {
      document.body.classList.remove('myroom-user-active');
      document.body.classList.remove('nav-active');
    };
  }, [toggleMenu, currentPath, isSidebarOpen]);

  useEffect(() => {
    const handleNavToggle = () => {
      const navToggler = sessionSetter.getItem<boolean>('navToggler') ?? true;
      setIsSidebarOpen(navToggler);
    };

    window.addEventListener('navTogglerChange', handleNavToggle);

    return () => {
      window.removeEventListener('navTogglerChange', handleNavToggle);
    };
  }, []);

  const isExcluded = useMemo(() => {
    return (
      excludedModules.has(currentPath) ||
      excludedPages.has(pathname) ||
      pathname.includes('/rides/information') ||
      pathname.includes('/standing-order/details')
    );
  }, [currentPath, pathname]);

  const centralWidth = useMemo(() => {
    if (isExcluded) return '100%';

    const widthMap: Record<string, string> = {
      'true-true': '977px',
      'false-true': '1251px',
      'true-false': '1022px',
      'false-false': '1296px',
    };

    return widthMap[`${toggleMenu}-${isSidebarOpen}`] || '1296px';
  }, [toggleMenu, isSidebarOpen, isExcluded]);

  return {
    isExcluded,
    centralWidth,
    toggleNav: isSidebarOpen,
    toggleMenu,
    setToggleMenu,
  };
};
